// components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      className="bg-secondary-800 dark:bg-secondary-900 text-secondary-300 dark:text-secondary-400 py-8 mt-auto"
      role="contentinfo"
    >
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center text-sm">
          <p className="mb-2">
            © {new Date().getFullYear()} הקודש במרכז – מחוז חיפה - מאגר חומרים למורי קודש
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link
              to="/about"
              className="hover:text-white transition-colors"
            >
              אודות
            </Link>
          <a
            href="mailto:haifakodesh@gmail.com"
              className="hover:text-white transition-colors"
            >
              צור קשר
            </a>
            <span className="text-secondary-500">|</span>
            <span className="text-secondary-500">
              מפתח האתר - הרב אפרים שרם
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}